/**
 * Slugs identify projects, games and communities in URLs (e.g. `stack-tower`).
 * Lowercase ASCII letters and digits, single hyphens between words.
 */
export const SLUG_MIN_LENGTH = 3;
export const SLUG_MAX_LENGTH = 32;

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function isValidSlug(value: string): boolean {
  return (
    value.length >= SLUG_MIN_LENGTH && value.length <= SLUG_MAX_LENGTH && SLUG_PATTERN.test(value)
  );
}

/**
 * Turns a display name into a slug candidate. The result may still be too short
 * or already taken, so callers must check it with `isValidSlug` and for uniqueness.
 */
export function toSlug(input: string): string {
  return input
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SLUG_MAX_LENGTH)
    .replace(/-+$/, '');
}
